module.exports = __webpack_public_path__ + "img/ms_b1_img3.43e25e27.png";